import { userDataRequest } from '../../lib/userDataRequest';

export const uploadMapDataFile = (fileContents) => {
  let formData = new FormData();
  formData.append('mapData', fileContents);

  return userDataRequest(
    'post',
    '/imports/upload',
    {
      headers: {
        'content-type': 'multipart/form-data'
      }
    },
    false,
    formData
  );
};

// This endpoint checks the status of the upload and returns
// an isValid and completed key
export const getImportDetails = (uploadId) => {
  return userDataRequest('get', `/imports/upload/${uploadId}`);
};

// This endpoint returns the list of features that were 
// successfully imported
export const getImportDataById = (importId) => {
  /*
    * #TODO Remove after deployment of latest UDAPI imports service
    * Must remove conditions in UDAPI before deployment
      - 10-27-22 JT
  */
  const params = {
    headers: { 'API-Version': 'v2' }
  }
  return userDataRequest('get', `/imports/${importId}`, params );
};

export const deleteImportById = (importId) => {
  return userDataRequest('delete', `/imports/${importId}`);
};